import { render, staticRenderFns } from "./ShowCampaign.vue?vue&type=template&id=32127a15&scoped=true"
import script from "./ShowCampaign.vue?vue&type=script&lang=ts"
export * from "./ShowCampaign.vue?vue&type=script&lang=ts"
import style0 from "./ShowCampaign.vue?vue&type=style&index=0&id=32127a15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32127a15",
  null
  
)

export default component.exports